module.exports = __webpack_public_path__ + "img/centro-comercial.1c1ac55e.svg";